export function isIframe(): boolean {
  return window && window.self !== window.top;
}
